<div mat-dialog-title class="modal-title">
  <mat-icon>copy_all</mat-icon>
  <span>Clonar examen desde: {{ examName }}</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  <form [formGroup]="examForm" autocomplete="off">
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline">
        <mat-label>Nombre del nuevo examen</mat-label>
        <input matInput type="text" placeholder="Nombre del nuevo examen" formControlName="name" name="examName" autocomplete="off" />
        <mat-error>Nombre del nuevo examen requerido</mat-error>
      </mat-form-field>
    </div>
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline">
        <mat-label>¿A qué curso pertenecerá el nuevo examen?</mat-label>
        <mat-select placeholder="Selecciona uno" formControlName="courseId" name="examCourse">
          @for (course of courses; track course.courseId) {
            <mat-option [value]="course.courseId">
              {{ course.name }}
            </mat-option>
          }
        </mat-select>
        <mat-error>Curso del examen requerido</mat-error>
      </mat-form-field>
    </div>
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline">
        <mat-label>¿A qué materia pertenecerá el nuevo examen?</mat-label>
        <mat-select placeholder="Selecciona uno" formControlName="sectionId" name="examSection">
          <mat-option [value]="null">-</mat-option>
          @for (section of sections; track section.courseSectionId) {
            <mat-option [value]="section.courseSectionId">
              {{ section.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button mat-flat-button color="primary" (click)="cloneExam()" [disabled]="examForm.invalid || isSavingExam">
    @if (!isSavingExam) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
